import { Col, Container, Row } from "reactstrap";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

const Galery = () => {

  const listGalery = [
    { name:"Molecular Cuisine Medium", img:"assets/images/gallery/gallery1.webp" },
    { name:"Sustainability Team Small", img:"assets/images/gallery/gallery2.webp" },
    { name:"BHMS Team", img:"assets/images/gallery/gallery3.webp" },
    { name:"Inducation Day Nov 2025", img:"assets/images/gallery/gallery4.webp" },
    { name:"Making Chocolate Lucerne International School", img:"assets/images/gallery/gallery5.webp" },
    { name:"7 hospitality skills to add to your resume", img:"assets/images/gallery/gallery6.webp" },
  ]

  return (
    <section className="section" id="galery">
      <Container>
        <Row className="">
            <LightGallery
              speed={500}
              plugins={[lgThumbnail, lgZoom]}
              selector=".masonry-item"
              download={false}
            >
              <div className="masonry">
                {listGalery.map((item, id) => (
                  <a 
                    key={id} 
                    href={item.img}
                    className="masonry-item"
                  >
                    <img 
                      alt={item.name} 
                      src={item.img} 
                      className="img-fluid" 
                    />
                  </a>  
                ))}      
              </div>            
            </LightGallery>   
        </Row>
      </Container>
    </section>
  );
};

export default Galery;